import { forwardRef } from "react";
import { isWeb, styled, Text as TamaguiText } from "@tamagui/core";
import { ComponentWithViewTracking } from "../../helpers/analytics.mjs";
import { jsx } from "react/jsx-runtime";
const BaseText = styled(TamaguiText, {
    name: "BaseText",
    fontFamily: "$body",
    color: "$contentPrimary",
    variants: {
      typography: {
        "...fontSize": fontSize => ({
          fontSize,
          fontWeight: fontSize,
          letterSpacing: fontSize,
          lineHeight: fontSize
        })
      }
    }
  }),
  isHeading = ({
    tag,
    typography
  }) => tag ? ["h1", "h2", "h3", "h4", "h5", "h6"].includes(tag) : !!typography && typography.startsWith("$header"),
  isParagraph = ({
    tag,
    typography
  }) => tag ? tag === "p" : !!typography && typography.startsWith("$body"),
  getDefaultProps = props => {
    const defaultProps = {};
    return isHeading(props) && (defaultProps.accessibilityRole = "header"), isParagraph(props) && (defaultProps.userSelect = "auto"), isWeb && (defaultProps.display = isParagraph(props) || isHeading(props) ? "block" : "inline"), defaultProps;
  },
  Text = forwardRef(function ({
    analyticsName,
    trackImpression = !1,
    ...props
  }, ref) {
    const defaultProps = getDefaultProps(props),
      BaseTextWithProps = /* @__PURE__ */jsx(BaseText, {
        ref,
        ...defaultProps,
        ...props
      });
    return analyticsName && trackImpression ? /* @__PURE__ */jsx(ComponentWithViewTracking, {
      Component: BaseTextWithProps,
      analyticsName,
      eventName: "textViewEvent",
      ref
    }) : BaseTextWithProps;
  }),
  StyleableText = BaseText.styleable((props, ref) => /* @__PURE__ */jsx(BaseText, {
    ref,
    ...props
  }));
export { StyleableText, Text, getDefaultProps };